import { render } from "./BatchClassSubView.vue?vue&type=template&id=2debe6f4&ts=true"
import script from "./BatchClassSubView.vue?vue&type=script&lang=ts"
export * from "./BatchClassSubView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__